import { Css, Icon, Tooltip } from "@homebound/beam";
import { AddProductOfferingConfig_ReadyPlanOptionsFragment } from "src/routes/libraries/product-offering-configs/AddProductOfferingConfigPage.generated";
import { pluralize } from "src/utils";

export function PrereqTag(props: {
  preReqs: AddProductOfferingConfig_ReadyPlanOptionsFragment["optionPrerequisites"];
}) {
  const { preReqs } = props;

  return (
    <Tooltip
      title={
        <>
          <p>Preqrequisite(s):&nbsp;{preReqs.map((pr) => pr.displayName).join(", ")}</p>
          <br />
          <p>Prereqs are auto removed if this option is deselected</p>
        </>
      }
    >
      <div css={Css.df.gap1.aic.yellow500.$}>
        <Icon icon="errorCircle" /> {pluralize(preReqs.length, "Prerequisite")}
      </div>
    </Tooltip>
  );
}
